'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Back';
import EtablishmentForm from 'Components/Forms/Models/Etablishment/EtablishmentForm';
import Link from 'Pure/Link';
import QrCodeIcon from 'Icons/QrCode';
import { URL, action } from 'Shared/Routes';
const {
  app
} = window;
function getIdFromPath() {
  let pathname = document.location.pathname;
  if (pathname.endsWith('/') && pathname !== '/') {
    pathname = pathname.slice(0, -1);
  }
  return pathname.slice(pathname.lastIndexOf('/') + 1);
}
export default class UpdateEtablishmentPage extends Component {
  state = {
    roles: [],
    id: getIdFromPath()
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (app?.state?.session?.user?.roles?.length > 0) {
      component.setState({
        roles: app.state.session.user.roles
      });
    }
    app.push({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
  }
  componentDidUpdate() {
    const component = this,
      props = this.props,
      state = this.state;
    const id = getIdFromPath();
    if (state.id !== id) component.setState({
      id
    });
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
  }
  handleSessionChange = ({
    source,
    data
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      roles: app.state.session?.user?.roles || []
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const title = state.roles.includes('admin') ? 'Mise à jour d\'un établissement' : 'Mise à jour de mon établissement';
    const id_property = app.state.session?.user?._etablishment?.id_property || '';
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: title
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content"
    }, state.roles.includes('admin') ? /*#__PURE__*/React.createElement(Button, {
      component: Link,
      href: URL('AdminEtablishmentsDashboard'),
      className: "u-margin-bottom-15"
    }, '<', " Retour aux \xE9tablissements") : state.id ? /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-text-right"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "text",
      color: "primary",
      href: action('getQRCodePDF').replace(':etablishment_id', state.id).replace(':id_property', id_property),
      className: "u-margin-bottom-20",
      title: "PDF du QR Code",
      target: "_blank",
      type: "application/pdf",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/React.createElement(QrCodeIcon, {
      color: "primary",
      className: "u-margin-right-10"
    }), "Imprimer mon affiche myWo")) : undefined, /*#__PURE__*/React.createElement(EtablishmentForm, {
      type: "update",
      roles: state.roles,
      key: state.id
    })));
    return output;
  }
}
